import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#004b40',
                secondary: '#e0e0e0',
                accent: '#1feb00',
                error: '#ff4444',
                warning: '#FFA726'
            }
        },
        icons: {
            iconfont: 'mdi',
        },
        lang: {
            current: 'es_ES'
        }
    },
});
